import { render, staticRenderFns } from "./InstanceShareItemOwner.vue?vue&type=template&id=420ded84&scoped=true"
import script from "./InstanceShareItemOwner.vue?vue&type=script&lang=js"
export * from "./InstanceShareItemOwner.vue?vue&type=script&lang=js"
import style0 from "./InstanceShareItemOwner.vue?vue&type=style&index=0&id=420ded84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ded84",
  null
  
)

export default component.exports